export enum LocalStorageKeys {
    BUILDINGS = 'edl_portal_buildings',
    PERMISSIONS = 'edl_permissions',
    ROLES_I_CAN_MANAGE = 'edl_roles_i_can_manage',
    ROLES_I_CAN_MANAGE_PER_BUILDING = 'edl_roles_i_can_manage_per_building',
    HAS_LOADED_DATA = 'paetep_has_loaded_data',
    MY_TARGET_PEERS = 'paete_my_target_peers',
    USER = 'user',

    // User Details
    USER_DETAILS_CACHE = 'edl_user_details_cache',
    FULL_USER_DETAILS_CACHE = 'edl_full_user_details_cache',


    // DEFAULTS
    USER_DEFAULT_BUILDING = 'user-default-building',
    USER_DEFAULT_ROLE_SEARCH = 'user-default-role-search',
    USER_DEFAULT_SEARCH_STRING = 'user-default-search-string',
    USER_DEFAULT_SUPERVISOR_ONLY = 'user-default-supervisor-only',
    USER_DEFAULT_PEER_EVALUATORS = 'user-default-peer-evaluators',

    // Evaluator Completion Report (session-sticky filters, PAE2-3503)
    EVALUATOR_COMPLETION_REPORT_BUILDING_FILTER = 'evaluator-completion-report-building-filter',
    EVALUATOR_COMPLETION_REPORT_DATE_RANGE = 'evaluator-completion-report-date-range'
}